module.exports = __webpack_public_path__ + "static/media/ThePowerOfNature.ffd4bc2e.mp3";